import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router';
import { fetchInvitationDetails } from '../../apiCall';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import TopBaner from '../TopBaner/topBaner';
import SideBar from '../SideBar/sideBar';
import './generateCard.scss';

function GenerateCard() {
  const { id, date } = useParams(); 
  const [saveTravel, setSaveTravel] = useState(null); 
  const [travelURL, setTravelURL] = useState();
  const [travelURLimg, setTravelURLimg] = useState();
  const [editURL, setEditURL] = useState();
  const [qrLoaded, setQrLoaded] = useState(false);
  const [showSpinner, setShowSpinner] = useState(true);
  const containerRef = useRef(null);

  useEffect(() => {
    getInvitation();
  }, []);

  const normalizeResponse = (resp) => {
    console.log('Raw response:', resp);
    if(!resp || !resp.result) {
      return null;
    }
    const raw = resp?.result?.data || resp?.result || resp || {};
    const normalized = {
      id: raw.id || id,
      data: {
        travelType: raw.travelType || raw?.data?.travelType || 'sadir',
        date: raw.date || raw?.data?.date || '',
        time: raw.time || raw?.data?.time || '',
        orbit: raw.orbit || raw?.data?.orbit || {},
        note: raw.note || raw?.data?.note || '',
        travelBack: raw.travelBack || raw?.data?.travelBack || null,
        name: raw.name || raw?.data?.name || '',
        englishName: raw.englishName || raw?.data?.englishName || '',
        flightNumber: raw.flightNumber || raw?.data?.flightNumber || '',
        amount: raw.amount || raw?.data?.amount || '',
        phonNumber: raw.phonNumber || raw?.data?.phonNumber || '',
        notes: raw.notes || raw?.data?.notes || '',
        localID: raw.localID || raw?.data?.localID || '',
        signature: raw.signature || raw?.data?.signature || '',
        terms: raw.terms || raw?.data?.terms || '' , 
        pricePercent: raw.pricePercent || raw?.data?.pricePercent || '',
        originData: raw.originData || raw?.data?.originData || '' , 
        newDate: resp.result.newDate || raw?.data?.newDate || '' , 
        newOrbit : resp.result.newOrbit || raw?.data?.newOrbit || '' ,
        side :  raw.orbit.code || '' 
      }
    };
    console.log('Normalized response:', normalized , resp.newDate);
    return normalized;
  };

  const getInvitation = () => {
    fetchInvitationDetails(id, 'sadir', date, function (response) {
      const normalized = normalizeResponse(response);
      if(!normalized) {
        setShowSpinner(false);
        return;
      }
      setSaveTravel(normalized);

      const unixTimestamp = Number(date); 
      const qrCodeUrl = `https://pych-customers.firebaseapp.com/verifyInvite/${normalized.id}/${normalized.data.travelType}/${unixTimestamp}`;
      setTravelURL(qrCodeUrl);

      const qrCodeImageUrl = `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(qrCodeUrl)}`;
      setTravelURLimg(qrCodeImageUrl);

      const url = `https://pych-customers.firebaseapp.com/${normalized.id}/${normalized.data.travelType}/${unixTimestamp}`;
      setEditURL(url);
    });
  };

  const handleDownloadPDF = async () => {
    const pdf = new jsPDF('p', 'mm', 'a4');
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    const newPageSections = containerRef.current?.querySelectorAll('.newPage');
    if (!newPageSections || newPageSections.length === 0) return;

    for (let i = 0; i < newPageSections.length; i++) {
      const section = newPageSections[i];

      const originalWidth = section.style.width;
      section.style.width = '794px'; 

      const canvas = await html2canvas(section, {
        scale: 3,
        useCORS: true,
        logging: false,
        windowWidth: section.scrollWidth,
        windowHeight: section.scrollHeight
      });

      section.style.width = originalWidth;

      const imgData = canvas.toDataURL('image/png', 1.0);
      const imgWidth = pageWidth;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      if (i > 0) pdf.addPage();
      pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight > pageHeight ? pageHeight : imgHeight);
    }

    pdf.save('קבלה מפאייכלה.pdf');
  };

  useEffect(() => {
    if (saveTravel && travelURLimg && qrLoaded) {
      setShowSpinner(false);
      console.log(saveTravel , saveTravel.data.originData.side)
      const t = setTimeout(() => handleDownloadPDF(), 500);
      return () => clearTimeout(t);
    }
  }, [saveTravel, travelURLimg, qrLoaded]);

  return (
    <div>
      <TopBaner />
      <SideBar />
      <style>{`
        .newPage {
          width: 400px; /* on screen */
          max-width: 100%;
          margin: 0 auto;
          padding: 32px;
          box-sizing: border-box;
          background: white;
          font-family: 'Arial', sans-serif;
          border: 1px solid #ddd;
          border-radius: 12px;
        }
        .parameter {
          display: flex;
          justify-content: space-between;
          padding: 8px 0;
          border-bottom: 1px dashed #eee;
        }
        .headerBack {
          text-align: center;
          margin-top: 12px;
          margin-bottom: 12px;
        }
      `}</style>

      <div className="paymentCard" ref={containerRef} style={{ padding: '2rem' }}>
        {showSpinner ? (
          <div style={{ textAlign: 'center', marginTop: '50px' }}>
            <p style={{ fontSize: '18px', marginBottom: '20px' }}>...טוען כרטיס נסיעה</p>
            <div className="spinner" />
            <style>{`
              .spinner {
                border: 4px solid rgba(0, 0, 0, 0.1);
                border-left-color: #3f51b5;
                border-radius: 50%;
                width: 40px;
                height: 40px;
                animation: spin 1s linear infinite;
              }

              @keyframes spin {
                0% {
                  transform: rotate(0deg);
                }
                100% {
                  transform: rotate(360deg);
                }
              }
            `}</style>
          </div>
        ) : (
          <></>
        )}

        {!showSpinner && !saveTravel? (
           <div style={{ textAlign: 'center', marginTop: '20px', direction: 'rtl' }}>
            <p style={{ fontSize: '16px', margin: 0}}>
              לא הצלחנו למצוא את הנסיעה שלך
            </p>
            <p>אנא בדוק שהקישור תקין</p>
          </div>
      ) : <></>}

        {saveTravel ? (
          <div style={{ textAlign: 'center' }}>
            {/* First Page */}
            <div className="newPage">
              <img style={{ margin: 0, height: '100px' }} src="/pycBlueIogo.png" alt="logo-pych" />
              <h6 className="headerBack">:  
                {saveTravel.data.side == 'ka' ?  'נסיעת הלוך' : 'נסיעת חזור' }
              </h6>

              <div className="parameter">
                <span>{saveTravel.data.travelType === 'sadir' ? 'סדירה ' : 'פרטית'}</span>
                <span>: סוג נסיעה</span>
              </div>

              <div className="parameter">
                <span>{saveTravel.data.pricePercent.toFixed(2)}</span>
                <span>: מחיר</span>
              </div>

              <div className="parameter">
                <span>{ saveTravel.data.newDate || saveTravel.data.date}</span>
                <span>: תאריך</span>
              </div>

              <div className="parameter">
                <span>{ saveTravel.data.newOrbit ? (saveTravel.data.newOrbit?.hour + ":" + saveTravel.data.newOrbit?.minutes) :  saveTravel.data.time}</span>
                <span>: שעה</span>
              </div>

              <div className="parameter">
                <span>
                  { saveTravel.data.newOrbit.name ||  saveTravel.data.orbit?.hebrewAdress ||
                    saveTravel.data.orbit?.name ||
                    ''}
                </span>
                <span>: מסלול</span>
              </div>

              {saveTravel.data.orbit?.note ? (
                <div className="parameter">
                  <span>{saveTravel.data.orbit.note}</span>
                  <span>: הערה</span>
                </div>
              ) : null}

              {saveTravel.data.travelBack ? (
                <>
                  <h6 className="headerBack">: נסיעת חזור</h6>
                  <div className="parameter">
                    <span>{saveTravel.data.travelBack.travelType === 'sadir' ? 'סדירה ' : 'פרטית'}</span>
                    <span>: סוג נסיעה</span>
                  </div>
                  <div className="parameter">
                  <span>{saveTravel.data.travelBack.priceBackPercent.toFixed(2)}</span>
                  <span>: מחיר</span>
                  </div>
                  <div className="parameter">
                    <span>{saveTravel.data.travelBack.newDate || saveTravel.data.travelBack.date}</span>
                    <span>: תאריך</span>
                  </div>
                  <div className="parameter">
                  <span>{ saveTravel.data.travelBack.newOrbit ? (saveTravel.data.travelBack.newOrbit?.hour + ":" + saveTravel.data.travelBack.newOrbit?.minutes) :  saveTravel.data.travelBack.time}</span>
                    <span>: שעה</span>
                  </div>
                  <div className="parameter">
                    <span>
                        { saveTravel.data.travelBack.newOrbit.name ||  saveTravel.data.orbit?.hebrewAdress ||
                    saveTravel.data.orbit?.name ||
                    ''}
                    </span>
                    <span>: מסלול</span>
                  </div>
                  {saveTravel.data.travelBack.orbit?.note ? (
                    <div className="parameter">
                      <span>{saveTravel.data.travelBack.orbit.note}</span>
                      <span>: הערה</span>
                    </div>
                  ) : null}
                </>
              ) : null}

              <h6 className="headerBack">: פרטי נוסע</h6>
              <div className="parameter">
                <span>{saveTravel.data.name}</span>
                <span>: שם</span>
              </div>
              {/* <div className="parameter">
                <span>{saveTravel.data.englishName}</span>
                <span>: שם באנגלית</span>
              </div> */}
              <div className="parameter">
                <span>{saveTravel.data.flightNumber}</span>
                <span>: מספר טיסה</span>
              </div>
              <div className="parameter">
                <span>{saveTravel.data.amount}</span>
                <span>: כמות</span>
              </div>
              <div className="parameter">
                <span>{saveTravel.data.phonNumber}</span>
                <span>: טלפון</span>
              </div>
              <div className="parameter">
                <span>{saveTravel.data.localID}</span>
                <span>: מזהה לקוח</span>
              </div>

              <p>: חתימה</p>
              <br />
              {saveTravel.data.signature ? (
                <img
                  src={saveTravel.data.signature}
                  alt="signature"
                  style={{ maxWidth: '200px' }}
                />
              ) : null}
            </div>

            <br />

            {/* Second Page */}
            <div className="newPage">
              {travelURLimg ? (
                <img
                  src={travelURLimg}
                  alt="QR"
                  style={{ marginTop: '10px' }}
                  onLoad={() => setQrLoaded(true)}
                />
              ) : null}
              <p style={{ fontWeight: 'bold', marginTop: '10px' }}>
                קבלה וכרטיס ישלחו גם למייל
              </p>
              <p style={{ fontWeight: 'bold' }}>נסיעה טובה</p>
              <p style={{ fontWeight: 'bold' }}>צוות פאייכלה</p>
            </div>

            {/* Third Page - Terms */}
            {saveTravel.data.terms ? (
              <div
                className="newPage"
                style={{ textAlign: 'right', direction: 'rtl' }}
                dangerouslySetInnerHTML={{ __html: saveTravel.data.terms }}
              />
            ) : null}
          </div>
        ) : <></>}

        {saveTravel? 
        <button className="optionsBtn pdfBtn" onClick={handleDownloadPDF}>
          הורד קובץ PDF
        </button>
        : null
        }
  
      </div>
    </div>
  );
}

export default GenerateCard;
